// extracted by mini-css-extract-plugin
export var label = "_46-1";
export var reminder = "_46-0";